module.exports = __webpack_public_path__ + "media/view/images/default_thumbnail-68d472a2818866ceb580ad5925577ea8.png";